import { BrokerInventoryPage } from '../broker-activity/BrokerInventoryPage';

interface BrokerInventoryCardProps {
  selectedStock: string;
  defaultExpanded?: boolean;
  isActive?: boolean;
}

export function BrokerInventoryCard({ selectedStock, defaultExpanded = false, isActive = true }: BrokerInventoryCardProps) {
  const overflowGuardClasses = 'w-full max-w-full overflow-x-auto md:overflow-x-visible';
  const shrinkWrapClasses = 'h-full min-w-0 [&_*]:min-w-0';

  return (
    <div className="bg-card rounded border border-border overflow-hidden h-full flex flex-col">
      <div className={`p-0 flex-1 overflow-y-auto ${overflowGuardClasses}`}>
        <div className={shrinkWrapClasses}>
          <BrokerInventoryPage 
            selectedStock={selectedStock} 
            defaultSplitView={false}
            hideControls={false}
            disableTickerSelection={true}
            isDashboard={true}
            isActive={isActive}
          />
        </div>
      </div>
    </div>
  );
}

